import { createTheme } from '@mui/material';

export const BlueTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#69779B',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#FFB900',
            contrastText: '#FFFFFF'
        },
        background: {
            default: '#1A2035',
            paper: '#1F283E'
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#B2B2B2',
            disabled: '#6C6C6C'
        },
        divider: '#484F61'
    },
});

